import React  from 'react';
import { render } from "react-dom";
import { BrowserRouter ,Routes, Route } from "react-router-dom";
import './index.css';
import './i18n';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import AOS from 'aos';
import 'aos/dist/aos.css';
import{ init } from 'emailjs-com';
import Alm7seb from './components/Alm7seb/Alm7seb';
import Resturant from './components/Resturant/Resturant';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

init("user_a5ssQEqOdOOJ69IJ81nJo");

require('dotenv').config()
AOS.init();

const rootElement = document.getElementById("root");

render(
   
  <BrowserRouter>
  <ScrollToTop />
   <Routes>
      <Route path="/" element={<App />} />
      <Route path="/Alm7seb" element={<Alm7seb />} />
      <Route path="/Resturant" element={<Resturant />} />
    </Routes>
    
  </BrowserRouter>,
  rootElement
);
